// extracted by mini-css-extract-plugin
module.exports = {"image":"image-masthead_image__L0a9U"};